import thumbBlueExcess from "@/../static/img/source-thumbs/blue-excess.png";
import thumbBlueVRed from "@/../static/img/source-thumbs/blue-v-red.png";
import thumbNdwi from "@/../static/img/source-thumbs/ndwi.png";
import thumbNir from "@/../static/img/source-thumbs/nir.png";
import thumbPixelVariation from "@/../static/img/source-thumbs/pixel-variation.png";
import thumbPlanet from "@/../static/img/source-thumbs/planet.png";
import thumbStadia from "@/../static/img/source-thumbs/stadia.png";

export interface ImagerySource {
	id: string;
	short: string;
	title: string;
	desc: string;
	thumb: string;
}

// Planet imagery sources (single-select). Shared by the topbar dropdown
// (SatelliteImageControls) and the bottom-right layer selector.
export const IMAGERY_SOURCES: ImagerySource[] = [
	{
		id: "planet",
		short: "RGB",
		title: "Planet (RGB)",
		desc: "True-color satellite photo",
		thumb: thumbPlanet,
	},
	{
		id: "blue-excess",
		short: "Blue Excess",
		title: "Blue Excess",
		desc: "Blue brightness vs. overall brightness",
		thumb: thumbBlueExcess,
	},
	{
		id: "ndwi",
		short: "NDWI",
		title: "NDWI",
		desc: "Wetness — open water and moisture",
		thumb: thumbNdwi,
	},
	{
		id: "blue-v-red",
		short: "Blue-Red",
		title: "Blue vs Red",
		desc: "Water vs bare-soil contrast",
		thumb: thumbBlueVRed,
	},
	{
		id: "pixel-variation",
		short: "Variation",
		title: "Pixel Variation",
		desc: "Texture — smooth water glows bright",
		thumb: thumbPixelVariation,
	},
	{
		id: "nir",
		short: "NIR",
		title: "Near-Infrared",
		desc: "See water — dark in near-infrared",
		thumb: thumbNir,
	},
];

// Legacy: shown in the imagery menu only on pages that do not bind
// stadiaMode (review/training pages). Reveal replaces it with the
// bottom-right basemap toggle.
export const STADIA_SOURCE: ImagerySource = {
	id: "stadia",
	short: "Stadia",
	title: "Stadia Satellite",
	desc: "Satellite basemap (no Planet data)",
	thumb: thumbStadia,
};
